import { createAction, props } from "@ngrx/store";
import {
  IMaxxOptimizedBenefitDto,
  IMaxxOptimizerQueryDto,
} from "@core/models/http/treatment/treatment-plans/optimizer-dto";
import { CreateTreatmentPlan } from "../treatment-plans/models/create-treatment-plan";
import { ImaxxRules } from "./imaxx-rules";

export const imaxxEnabled = createAction(
  "[IMAXX] imaxx enabled",
  props<{ enabled: boolean }>()
);

export const fetchImaxxRules = createAction(
  "[IMAXX] fetching carrier rules",
  props<{ carrierId: number }>()
);
export const loadSuccess = createAction(
  "[IMAXX] fetch carrier rules success",
  props<ImaxxRules>()
);
export const loadFailure = createAction(
  "[IMAXX] fetch carrier rules failure",
  props<{ error: string }>()
);

export const treatmentPlanOptimized = createAction(
  "[Treatment Page] Treatment Plan Optimizer Created",
  props<{ treatmentPlan: CreateTreatmentPlan }>()
);

export const updateImaxxOptimizerSuccess = createAction(
  "[IMAXX] updated iMaxx optimizer",
  props<IMaxxOptimizerQueryDto>()
);

export const optimizedCalculateSuccess = createAction(
  "[IMAXX] optimized calculate success",
  props<IMaxxOptimizedBenefitDto>()
);

export const toggleSelectImaxxAdditionalCost = createAction(
  "[IMAXX] toggle iMaxx additional cost selection",
  props<{
    additionalCostId: number;
    selectedOn: Date;
    treatmentPlanId: number;
  }>()
);

export const resetImaxxOptimizer = createAction("[IMAXX] Treatment Plan Optimizer Reset");
